import React from 'react';

interface TooltipButtonProps {
  onClick(e: React.MouseEvent): void;
  icon?: React.ReactNode;
  children?: React.ReactNode;
}

export default class TooltipButton extends React.Component<TooltipButtonProps> {
  render() {
    const { children, icon, ...props } = this.props;
    return (
      <div {...props} className="button">
        {!!icon && <span className="icon">{icon}</span>}
        {children}
        <style jsx>{`
          .button {
            background: rgba(0, 0, 0, 0.2);
            border-radius: 8px;
            text-align: center;
            line-height: 32px;
            text-transform: uppercase;
            font-weight: bold;
            transition: all 200ms;
            cursor: pointer;
          }

          .button .icon {
            display: inline-block;
            margin-right: 10px;
          }

          .button:hover {
            background: rgba(0, 0, 0, 0.4);
          }

          .button:active {
            opacity: 0.8;
          }
        `}</style>
      </div>
    );
  }
}
